import React from "react";
import Layout from "./Layout";
import {Button, Card, CardActions, CardContent, Slide, Typography, Zoom} from "@mui/material";
import Cloud from "./Cloud";
import memoji from '../assets/memoji_home.jpg'
import blog_data from "./Data/blogs";
import HackTheBox from "../assets/HackTheBox.png"
import Footer from "./Footer";

const Home = () => {
    const Welcome = () => {
        return(
            <div className='container' style={{marginTop: '10%', padding: '5% 0'}}>
                <div className="row mt-3 mt-md-0">
                    <div style={{color: 'white'}} className='col-12 col-md-6'>
                        <Zoom in={true} timeout={1500}>
                            <div>
                                <Typography style={{fontSize: '16px'}}>
                                    HELLO FRIEND, I'M
                                </Typography>
                                <Typography style={{fontWeight: '600', fontSize: '72px', lineHeight: '86px'}}>
                                    Simardeep Singh
                                </Typography>
                                <Typography variant='h5' style={{marginTop: '2%', color: '', fontWeight: 'bold'}}>
                                    a.k.a. tombstoneGhost
                                </Typography>
                                <Typography variant='h5' style={{marginTop: '5%', color: '#BC6FF1', fontWeight: 'bold'}}>
                                    Cyber Security Enthusiast + Developer
                                </Typography>
                                <Typography variant='h6' style={{marginTop: '5%'}}>
                                    A Penetration Tester who loves to <br/>
                                    develop applications and explore.
                                </Typography>
                            </div>
                        </Zoom>
                    </div>
                    <div className='col-12 col-md-6 text-md-right mt-4 mt-md-0'>
                        <Slide in={true} direction="left" timeout={1500}>
                            <img src={memoji} alt={'profile'} height="100%" width="85%"/>
                        </Slide>
                    </div>
                </div>
            </div>
        )
    }

    const About = () => {
        return (
            <div style={{marginTop: '8%', display: 'flex', backgroundColor: '#212529',
                color: 'white', padding: '10% 0'}}>
                <div className="container">
                    <div className='row'>
                        <div className="col-6 col-md-6 text-md-left" style={{margin: 'auto'}}>
                            <Cloud />
                        </div>
                        <div className="col-12 col-md-6 text-md-left">
                            <Typography className="text-center mb-3" variant="h2" style={{fontWeight: 'bold'}}>
                                $ whoami
                            </Typography>
                            <Typography variant="h6" style={{fontSize: '18px'}}>
                                An upcoming graduate, currently working as a Network Engineer Trainee at
                                Hughes Systique Corporation (HSC) and pursuing Bachelor's of Technology in
                                Computer Science Engineering with Specialization in Cyber Security and Forensics at
                                University of Petroleum and Energy Studies (UPES), Dehradun. With an aim to make
                                a revolutionary change in the field of Computer Science and a habit of thinking
                                out of the box, I keep trying new things and experimenting with stuff just to learn
                                more about them and to prove my engineering traits.
                                <br/><br/>
                                As mentioned in the tagline, my interest lies in Offensive Security, specifically into
                                Application Security and Network Security. But to keep myself updated with the
                                latest trends I am extending my interest into other domains like Cloud Security,
                                DevSecOps and into Forensics. So, just in case you would like to get mentored or have
                                any query feel free to get in touch with me.
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    const RecentBlogs = () => {

        const card_colors = ["#ff0000", "#00ff00", "#0000ff"]

        const blogs = blog_data.slice(0, 3);

        return (
            <div style={{backgroundColor: '#212529', color: 'white', paddingBottom: '10%'}}>
                <div className="container">
                    <div className="text-center" style={{marginBottom: '5%'}}>
                        <Typography variant="h3">
                            Recent Blogs
                        </Typography>
                    </div>
                    <div className="row">
                        {blogs.map((data, index) => (
                            <div className="col-12 col-md-4">
                                <Card style={{width: '100%', height: '100%',
                                    backgroundColor: '#2b2b2b', color: 'white',
                                    borderBottom: `5px solid ${card_colors[index]}`}} raised>
                                    <CardContent className="text-center">
                                        <Typography variant="h6">
                                            {data.title}
                                        </Typography>
                                        <div style={{margin: '5% 0'}}>
                                            {data.title.includes("HackTheBox") ? (
                                                <img src={HackTheBox} alt={data.title} width="100%" height="100%" />
                                            ) : (<img src={data.banner} alt={data.title} width="100%" height="100%"/>)
                                            }
                                        </div>
                                        <Typography>
                                            {data.summary}
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button className="ml-auto mr-auto mb-3" variant="outlined" color="inherit">
                                            <a href={data.url} style={{textDecoration: 'none', color: 'white'}}
                                                target="_blank" rel="noreferrer">
                                                Read More
                                            </a>
                                        </Button>
                                    </CardActions>
                                </Card>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Layout>
            <Welcome />
            <About />
            <RecentBlogs />
            <Footer bgColor="#212529"/>
        </Layout>
    )
};

export default Home;